// src/Chat.js
import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const response = await axios.post(`${backendUrl}/conversation/start`);
const conversationId = response.data.conversationId;


function Chat() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const textareaRef = useRef(null);
  const messagesEndRef = useRef(null);

  const sendMessage = async () => {
    console.info(input);
    if (input.trim() === '') return;

    const userMessage = { role: 'user', content: input };
    const updatedMessages = [...messages, userMessage];

    setMessages(updatedMessages);
    setInput('');
    textareaRef.current.value = '';

    try {
      const response = await axios.post(`${backendUrl}/conversation/${conversationId}/message`, {
        message: input
      });
      console.info(response.data);
      const assistantMessage = response.data;
      setMessages([...updatedMessages, {role: 'assistant', content: assistantMessage.text}]);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevents adding a new line
      sendMessage();
    }
  };

  const updateCaretPosition = () => {
    const textarea = textareaRef.current;
    if (textarea) {
    const caretPos = textarea.selectionStart;
      textarea.style.setProperty('--caret-position', caretPos);
    }
  };

  return (
    <>
    <h1 className="terminal-header">_Console v1.0.0</h1>
    <div className="chat-container">
      <div className="messages">
        {messages.map((msg, idx) => (
          <div key={idx} className={`message ${msg.role}`}>
            <p>{msg.content}</p>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
      <div className="input-container">
        <textarea
          ref={textareaRef}
          onChange={(e) => {
            setInput(e.target.value);
            updateCaretPosition();
          }}
          onKeyUp={handleKeyDown}
          onClick={updateCaretPosition}
          placeholder="Type your message... (Enter to send)"
        />
        <button onClick={sendMessage}>Send</button>
      </div>
    </div>
    </>
  );
}

export default Chat;
